module.exports = __webpack_public_path__ + "static/media/Spring.984b0566.png";